
<template> 
    <CardRh :processando="processando" titulo="Etapa 1/4 - Insira o dia e horário" >  
        <div class="row"> 
            <div class="col-12 col-sm-6 col-lg-4" > 
                <div class="form-group"> 
                    <label for="dia" class="form-check-label">Data:</label>   
                    <input required type="date"  name="dia" class="form-control" v-model="dia" :max="hj" >  
                </div>
            </div>  
            <div class="col-12 col-sm-6 col-lg-4" > 
                <div class="form-group"> 
                    <label for="inicio" class="form-check-label">Início:</label>   
                    <input min="06:00" max="22:00" type="time" name="inicio" class="form-control" v-model="inicio"   v-on:input="calculaFim()" required>  
                </div>
            </div>  
            <div class="col-12 col-sm-6 col-lg-4" > 
                <div class="form-group"> 
                    <label for="fim" class="form-check-label">Fim:</label>   
                    <input min="06:00" max="23:00" type="time" name="fim" class="form-control" v-model="fim" disabled required>  
                </div>
            </div>  
        </div>  
        <br>
        <div>
            <button   class="btn btn-pmes-danger  float-left  " @click="cancelar">
                <i class=" fa fa-angle-left "></i> <span v-html="'&nbsp'"></span> Cancelar
            </button>
            <button class="btn btn-success  float-right" @click="nextPage( )">
                Próxima <span v-html="'&nbsp'"></span> <i class=" fa fa-angle-right "></i>
            </button>
        </div> 
    </CardRh>   
</template>

<script lang="ts"> 
 
    import CardRh from "@/components/cards/ManzaCard.vue" 
    import { Options , Vue  } from "vue-class-component";  
    import {  Prop } from 'vue-property-decorator';    
    
    @Options({
        name: "ControladorEtapa1",
        components: {  CardRh  },   
    }) 
    export default class ControladorEtapa1 extends Vue {
          
        @Prop( ) readonly service!: any 
        @Prop( ) readonly turmas_que_controlo!: any 
        @Prop( ) readonly formData!: any 
        @Prop( ) readonly processando!: any 
         
        public  meses =  ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];  
        public  dias =  ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];  

        public  dia: any =  null ;  
        public  inicio: any =  '07:30' ;  
        public  fim: any =  '08:20' ;  

        get hj() {
            return new Date().getFullYear() + '-' + this.meses[new Date().getMonth()] + '-' + this.dias[new Date().getDate()];
        } 
        
        get hj2() { 
            return new Date(2020, 2, 1, 0, 33, 0, 0);
        }
         
        mounted() {
            this.dia = new Date().getFullYear() + '-' + this.meses[new Date().getMonth()] + '-' + this.dias[new Date().getDate()];
        }

        public calculaFim(){ 
            var pos = this.inicio.indexOf(":")
            var hora = parseInt( this.inicio.slice(0, pos) );
            var minuto =  parseInt( this.inicio.slice(  pos + 1 ) ) ; 
            let date = new Date(2020, 2, 1, hora , minuto , 0, 0).getTime() + 3000000;
            let fim = new Date(date) ; 
            this.fim =  ( "0" +  fim.getHours() ).slice(-2) + ':' + ( "0" +  fim.getMinutes() ).slice(-2)   ; 
        } 
        
        public nextPage() {
            this.$emit('nextPage', {
                formData: {
                    data: this.dia,
                    inicio: this.inicio+":00",
                    fim: this.fim+":00"
                },
                pageIndex: 0
            });
        }

        public cancelar() {
            this.$router.push({ name: "sigap_controlador"  }) ;
        }
         
    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
        padding: 0.55rem 1.25rem;
    } 
    .registro-alteracao{
        text-align: right;
    } 
    .float-left{
        float: left !important;
    } 
    .float-right{
        float: right;
    } 
    .col-12{
        margin-bottom: 20px;
    } 
</style>